
import AtkButton from "../../AtlaskitControls/AtkButton";
import { useEffect, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import MvrLogo from "../../assets/images/mvr.png";
export default function MVRDetailsPage(props: any) {
    const printRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef: printRef, });
    return (
       <>
        <div ref={printRef} className="report-container">
            <div className="print-button-container">
                <AtkButton label="Print" className="print-button pf-primary-btn w-auto" onClick={() => handlePrint()} />
            </div>
            <div className="col-12">
                <div className="">
                    <img src={MvrLogo} className="" width={30} />
                    <span className="report-header report-logo"><b>Motor Vehicle Record</b></span>
                </div>
            </div>{" "}
            <div className="section-header">
                <span className="text-14">
                    <b>Personal Information</b>
                </span>
            </div>
            <div className="info-grid report-header"></div>
                <table className="text-14" style={{ width: "100%", fontFamily: "Poppins" }}>
                    <tbody>
                        <tr>
                            <td style={{ width: "20%" }}>Name</td>
                            <td style={{ width: "30%" }}>
                                {`${props.personDetails?.firstName ?? ""} ${props.personDetails?.middleName ?? ""} ${props.personDetails?.lastName ?? ""}`}
                            </td>
                            <td style={{ width: "20%" }}>Sex</td>
                            <td style={{ width: "30%" }}>{props.personDetails?.gender ?? "N/A"}</td>
                        </tr>
                        <tr>
                            <td>Address</td>
                            <td>{props.personDetails?.address ?? "N/A"}</td>
                            <td>Eyes</td>
                            <td>{props.personDetails?.eyeColor ?? "N/A"}</td>
                        </tr>
                        <tr>
                            <td>Age</td>
                            <td>{props.personDetails?.age ?? "N/A"}</td>
                            <td>Hair</td>
                            <td>{props.personDetails?.hairColor ?? "N/A"}</td>
                        </tr>
                        <tr>
                            <td>Weight</td>
                            <td>{props.personDetails?.weight ?? "N/A"}</td>
                            <td>Date of Birth</td>
                            <td>{props.personDetails?.birthDate ?? "N/A"}</td>
                        </tr>
                    </tbody>
                </table>
            

            <div className="section-header">
                <span className="text-14">
                    <b>Violations</b>
                </span>
            </div>
            <table className="report-table report-header">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Code</th>
                        <th>Description</th>
                        <th>Location</th>
                        <th>Speed</th>
                        <th>ACD</th>
                        <th>AVD</th>
                    </tr>
                </thead>
                <tbody>
                    {props.voilationsDetails?.length > 0 ? (
                        props.voilationsDetails.map((violation: any, index: number) => (
                            <tr key={index}>
                                <td>{violation?.date ?? "N/A"}</td>
                                <td>{violation?.code ?? "N/A"}</td>
                                <td>{violation?.description ?? "N/A"}</td>
                                <td>{violation?.location ?? "N/A"}</td>
                                <td>{violation?.speed ?? "N/A"}</td>
                                <td>{violation?.acd ?? "N/A"}</td>
                                <td>{violation?.avd ?? "N/A"}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={7} style={{ textAlign: "center" }}>No Violations</td>
                        </tr>
                    )}
                </tbody>
            </table>

            <div className="section-header">
                <span className="text-14">
                    <b>Accidents</b>
                </span>
            </div>
            <table className="report-table report-header">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Code</th>
                        <th>Description</th>
                        <th>Location</th>
                        <th>ACD</th>
                        <th>AVD</th>
                    </tr>
                </thead>
                <tbody>
                    {props.accidentsDetails?.length > 0 ? (
                        props.accidentsDetails.map((accident: any, index: number) => (
                            <tr key={index}>
                                <td>{accident?.date ?? "N/A"}</td>
                                <td>{accident?.code ?? "N/A"}</td>
                                <td>{accident?.description ?? "N/A"}</td>
                                <td>{accident?.location ?? "N/A"}</td>
                                <td>{accident?.acd ?? "N/A"}</td>
                                <td>{accident?.avd ?? "N/A"}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={6} style={{ textAlign: "center" }}>No Accidents</td>
                        </tr>
                    )}
                </tbody>
            </table>

            <div className="section-header">
                <span className="text-14">
                    <b>License Information</b>
                </span>
            </div>
            <table className="report-table report-header">
                <thead>
                    <tr>
                        <th>Issue Date</th>
                        <th>Expire Date</th>
                        <th>Class</th>
                        <th>Class Description</th>
                        <th>Status</th>
                        <th>Restriction</th>
                        <th>CDL Type</th>
                        <th>CDL Expiration Date</th>
                    </tr>
                </thead>
                <tbody>
                    {props.licenseDetails?.length > 0 ? (
                        props.licenseDetails.map((licenseInfo: any, index: number) => (
                            <tr key={index}>
                                <td>{licenseInfo?.issueDate ?? "N/A"}</td>
                                <td>{licenseInfo?.expirationDate ?? "N/A"}</td>
                                <td>{licenseInfo?.class ?? "N/A"}</td>
                                <td>{licenseInfo?.classDescription ?? "N/A"}</td>
                                <td>{licenseInfo?.status ?? "N/A"}</td>
                                <td>{licenseInfo?.restrictions ?? "N/A"}</td>
                                <td>{licenseInfo?.cdlMedicalType ?? "N/A"}</td>
                                <td>{licenseInfo?.cdlMedicalExpirationDate ?? "N/A"}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={8} style={{ textAlign: "center" }}>No License Information</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
        </>
    )
}